
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delta-pro-ultra-daily-use",
      function () {
        return require("private-next-pages/delta-pro-ultra-daily-use/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delta-pro-ultra-daily-use"])
      });
    }
  